import Block from './Block'
import { Draggable } from 'gsap/Draggable'
import { gsap } from 'gsap'
import { InertiaPlugin } from 'gsap/InertiaPlugin'
import store from '../util/store'

// enregistrer le plugin
gsap.registerPlugin(InertiaPlugin)

export default class SliderHoverCards extends Block {
  getElems() {
    this.cards = Array.from(this.el.querySelectorAll('.b-slider-hover-cards__card'))
    this.container = this.el.querySelector('.slider__wrapper')
    this.draggable = this.el.querySelector('.slider__list')
  }

  init() {
    const isDesktop = window.matchMedia('(min-width: 768px)').matches

    if (isDesktop && this.draggable) {
      Draggable.create(this.draggable, {
        type: 'x',
        bounds: this.container,
        inertia: true,        // active le momentum
        edgeResistance: 0.65, // limite l'overshoot
      })
    }
  }

  events() {
    this.cards.forEach((card) => {
      const paragraph = card.querySelector('p')
      const arrow = card.querySelector('.arrow')
      const content = card.querySelector('.b-slider-hover-cards__card__content')
      const paragraphHeight = paragraph.offsetHeight

      let translateValue = paragraphHeight * 100 / 1512 + 3200 / 1512
      if (window.innerWidth >= 1024) translateValue = translateValue * (2000 / window.innerWidth)
      const initialTranslateValue = Math.min(translateValue, 100)

      content.style.transform = `translateY(${initialTranslateValue}vw)`

      card.addEventListener('mouseenter', () => {
        gsap.to(paragraph, { opacity: 1, alignSelf: 'flex-start', duration: 0.3 })
        gsap.to(arrow, { opacity: 0, duration: 0.3 })
        gsap.to(content, { y: '0vw', duration: 0.5, ease: 'power2.out' })
      })

      card.addEventListener('mouseleave', () => {
        gsap.to(paragraph, { opacity: 0, duration: 0.3 })
        gsap.to(arrow, { opacity: 1, duration: 0.3 })
        gsap.to(content, { y: `${initialTranslateValue}vw`, duration: 0.5, ease: 'power2.out' })
      })
    })

    this.container.addEventListener('mouseenter', () => {
      store.cursor.addState('-xl')
      store.cursor.setIcon('resources--assets--images--svg--arrow-double-white')
    })

    this.container.addEventListener('mouseleave', () => {
      store.cursor.removeState('-xl')
      store.cursor.removeIcon()
    })
  }
}
